var _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgLike(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 18,
    viewBox: "0 0 16 18",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_3691_117724)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M7.78581 1.45596C7.5044 1.48171 7.25385 1.68681 7.18685 1.98331L6.81706 3.61351L5.00977 5.62133C4.7891 5.86599 4.66732 6.18392 4.66732 6.51325V12.6682C4.66732 13.4049 5.26398 14.0015 6.00065 14.0015H11.3548C11.8488 14.0015 12.2961 13.7107 12.4967 13.2593L14.498 8.75544C14.6094 8.50611 14.6673 8.23581 14.6673 7.96247V7.33487C14.6673 6.60153 14.0673 6.00153 13.334 6.00153H8.66732C8.66732 6.00153 9.33398 4.42106 9.33398 3.24372C9.33398 2.16839 8.64227 1.69775 8.07227 1.49242C7.9771 1.45792 7.87961 1.44738 7.78581 1.45596ZM2.33398 6.00153C1.78198 6.00153 1.33398 6.44953 1.33398 7.00153V13.0015C1.33398 13.5535 1.78198 14.0015 2.33398 14.0015C2.88598 14.0015 3.33398 13.5535 3.33398 13.0015V7.00153C3.33398 6.44953 2.88598 6.00153 2.33398 6.00153Z"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_3691_117724"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    fill: "white",
    transform: "translate(0 1.33398)"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLike);
export default __webpack_public_path__ + "static/media/Like.9e21512e87994714db1e28d0aa99e09c.svg";
export { ForwardRef as ReactComponent };